import React from 'react';
import ProjectIcon from '@atlaskit/icon/core/project';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { AiPlannerIframeModalMenuItemWrapper } from '@jira/ai-planning__ai-planner-iframe-modal/src/AiPlannerIframeModalMenuItemWrapper.tsx';
import { Ati } from '@atlassian/ari/ati';
import { defineMessage, useIntl } from '@atlassian/jira-intl';
import type { MenuItem } from '@atlassian/universal-create/types';

const planWithJira = defineMessage({
	id: 'jira-ai.plan-with-jira.label',
	defaultMessage: 'Plan with Jira',
	description: 'The text for the plan with Jira item in the dropdown',
});

const eapLozenge = defineMessage({
	id: 'jira-ai.plan-with-jira.eap-lozenge',
	defaultMessage: 'EAP',
	description: 'The text for the EAP lozenge in the dropdown',
});

export function useCreateWithPlannerItem(): MenuItem {
	const { formatMessage } = useIntl();

	return {
		ati: Ati.parse('ati:cloud:jira:rovo'),
		children: (
			<Inline space="space.100">
				{formatMessage(planWithJira)}
				<Lozenge appearance="new">{formatMessage(eapLozenge)}</Lozenge>
			</Inline>
		),
		testId: 'jira-uc--create-with-planner-menu-item',
		elemBefore: ProjectIcon,
		Wrapper: AiPlannerIframeModalMenuItemWrapper,
	};
}
